<template>
  <div>

    <section class="feature-section">
      <div class="container">
        <div class="row ">

          <div class="col-12 text-left">

            <h2 class="align-left">Website Terms of Use</h2>

            <h3>Skippr Data Ltd - Terms of Use</h3>
            <p>These Terms govern the use of skipprdata.com and any other related Agreement or legal relationship with
              the Owner in a legally binding way. Capitalized words are defined in the relevant dedicated section of
              this document.</p>
            <p>The User must read this document carefully.</p>
            <p>skipprdata.com is provided by:</p>
            <p>Skippr Data Ltd</p>
            <p>Station House, Stamford New Road, Altrincham, Cheshire WA14 1EP</p>
            <p>Owner contact email: privacy@skipprdata.com</p>

            <h2>What the User should know at a glance</h2>
            <p>Please note that some provisions in these Terms may only apply to certain categories of Users. In
              particular, certain provisions may only apply to Consumers or to those Users that do not qualify as
              Consumers. Such limitations are always explicitly mentioned within each affected clause. In the absence of
              any such mention, clauses apply to all Users.</p>

            <h2>TERMS OF USE</h2>
            <p>Unless otherwise specified, the terms of use detailed in this section apply generally when using
              skipprdata.com.</p>
            <p>Single or additional conditions of use or access may apply in specific scenarios and in such cases are
              additionally indicated within this document.</p>
            <p>By using skipprdata.com, Users confirm to meet the following requirements:</p>
            <ul>
              <li>There are no restrictions for Users in terms of being Consumers or Business Users;</li>
            </ul>

            <h3>Account registration</h3>
            <p>To use the Service, Users must register or create a User account, providing all required data or
              information in a complete and truthful manner.</p>
            <p>Failure to do so will cause unavailability of the Service.</p>
            <p>Users are responsible for keeping their login credentials confidential and safe. For this reason, Users
              are also required to choose passwords that meet the highest standards of strength permitted by
              skipprdata.com.</p>
            <p>By registering, Users agree to be fully responsible for all activities that occur under their username
              and password. Users are required to immediately and unambiguously inform the Owner via the contact details
              indicated in this document if they think their personal information, including but not limited to User
              accounts, access credentials, or personal data, have been violated, unduly disclosed, or stolen.</p>

            <h3>Account termination</h3>
            <p>Users can terminate their account and stop using the Service at any time by doing the following:</p>
            <ul>
              <li>By using the tools provided for account termination on skipprdata.com.</li>
              <li>By directly contacting the Owner at the contact details provided in this document.</li>
            </ul>

            <h3>Account suspension and deletion</h3>
            <p>The Owner reserves the right, at its sole discretion, to suspend or delete at any time and without
              notice, User accounts which it deems inappropriate, offensive or in violation of these Terms.</p>
            <p>The suspension or deletion of User accounts shall not entitle Users to any claims for compensation,
              damages, or reimbursement.</p>
            <p>The suspension or deletion of accounts due to causes attributable to the User does not exempt the User
              from paying any applicable fees or prices.</p>

            <h3>Content on skipprdata.com</h3>
            <p>Unless where otherwise specified or clearly recognizable, all content available on skipprdata.com is
              owned or provided by the Owner or its licensors.</p>
            <p>The Owner undertakes its utmost effort to ensure that the content provided on skipprdata.com infringes no
              applicable legal provisions or third-party rights. However, it may not always be possible to achieve such
              a result. In such cases, without prejudice to any legal prerogatives of Users to enforce their rights,
              Users are kindly asked to preferably report related complaints using the contact details provided in this
              document.</p>

            <h3>Rights regarding content on skipprdata.com – All rights reserved</h3>
            <p>The Owner holds and reserves all intellectual property rights for any such content.</p>
            <p>Users may not, therefore, use such content in any way that is not necessary or implicit in the proper use
              of the Service.</p>
            <p>In particular, but without limitation, Users may not copy, download, share (beyond the limits set forth
              below), modify, translate, transform, publish, transmit, sell, sublicense, edit, transfer/assign to third
              parties or create derivative works from the content available on skipprdata.com, nor allow any third party
              to do so through the User or their device, even without the User’s knowledge.</p>
            <p>Where explicitly stated on skipprdata.com, the User may download, copy and/or share some content
              available through skipprdata.com for its sole personal and non-commercial use and provided that the
              copyright attributions and all the other attributions requested by the Owner are correctly
              implemented.</p>
            <p>Any applicable statutory limitation or exception to copyright shall stay unaffected.</p>

            <h3>Access to external resources</h3>
            <p>Through skipprdata.com, Users may have access to external resources provided by third parties. Users
              acknowledge and accept that the Owner has no control over such resources and is therefore not responsible
              for their content and availability.</p>
            <p>Conditions applicable to any resources provided by third parties, including those applicable to any
              possible grant of rights in content, result from each such third party’s terms and conditions or, in the
              absence of those, applicable statutory law.</p>

            <h3>Acceptable use</h3>
            <p>skipprdata.com and the Service may only be used within the scope of what they are provided for, under
              these Terms and applicable law.</p>
            <p>Users are solely responsible for making sure that their use of skipprdata.com and/or the Service violates
              no applicable law, regulations or third-party rights.</p>
            <p>Therefore, the Owner reserves the right to take any appropriate measure to protect its legitimate
              interests including by denying Users access to skipprdata.com or the Service, terminating contracts,
              reporting any misconduct performed through skipprdata.com or the Service to the competent authorities –
              such as judicial or administrative authorities – whenever Users engage or are suspected to engage in any
              of the following activities:</p>
            <ul>
              <li>violate laws, regulations, and/or these Terms;</li>
              <li>infringe any third-party rights;</li>
              <li>considerably impair the Owner’s legitimate interests;</li>
              <li>offend the Owner or any third party.</li>
            </ul>

            <h3>Software license</h3>
            <p>Any intellectual or industrial property rights, and any other exclusive rights on software or technical
              applications embedded in or related to skipprdata.com are held by the Owner and/or its licensors.</p>

            <p>Subject to Users’ compliance with and notwithstanding any divergent provision of these Terms, the Owner
              merely grants Users a revocable, non-exclusive, non-sublicensable and non-transferable license to use the
              software and/or any other technical means embedded in the Service within the scope and for the purposes of
              skipprdata.com and the Service offered.</p>
            <p>This license does not grant Users any rights to access, usage or disclosure of the original source code.
              All techniques, algorithms, and procedures contained in the software and any documentation thereto related
              is the Owner’s or its licensors’ sole property.</p>
            <p>All rights and license grants to Users shall immediately terminate upon any termination or expiration of
              the Agreement.</p>
            <h3>Liability and indemnification</h3>
            <h4>Australian Users</h4>
            <p>Limitation of liability</p>
            <p>Nothing in these Terms excludes, restricts or modifies any guarantee, condition, warranty, right or
              remedy which the User may have under the Competition and Consumer Act 2010 (Cth) or any similar State and
              Territory legislation and which cannot be excluded, restricted or modified (non-excludable right). To the
              fullest extent permitted by law, our liability to the User, including liability for a breach of a
              non-excludable right and liability which is not otherwise excluded under these Terms of Use, is limited,
              at the Owner’s sole discretion, to the re-performance of the services or the payment of the cost of having
              the services supplied again.</p>
            <h4>US Users</h4>
            <p>Disclaimer of Warranties</p>
            <p>skipprdata.com is provided strictly on an “as is” and “as available” basis. Use of the Service is at
              Users’ own risk. To the maximum extent permitted by applicable law, the Owner expressly disclaims all
              conditions, representations, and warranties — whether express, implied, statutory or otherwise, including,
              but not limited to, any implied warranty of merchantability, fitness for a particular purpose, or
              non-infringement of third-party rights. No advice or information, whether oral or written, obtained by the
              User from the Owner or through the Service will create any warranty not expressly stated herein.</p>
            <p>Without limiting the foregoing, the Owner, its subsidiaries, affiliates, licensors, officers, directors,
              agents, co-branders, partners, suppliers and employees do not warrant that the content is accurate,
              reliable or correct; that the Service will meet Users’ requirements; that the Service will be available at
              any particular time or location, uninterrupted or secure; that any defects or errors will be corrected; or
              that the Service is free of viruses or other harmful components. Any content downloaded or otherwise
              obtained through the use of the Service is downloaded at Users’ own risk and Users shall be solely
              responsible for any damage to Users’ computer system or mobile device or loss of data that results from
              such download or Users’ use of the Service.</p>
            <p>The Owner does not warrant, endorse, guarantee, or assume responsibility for any product or service
              advertised or offered by a third party through the Service or any hyperlinked website or service, and the
              Owner shall not be a party to or in any way monitor any transaction between Users and third-party
              providers of products or services.</p>
            <p>The Service may become inaccessible or it may not function properly with Users’ web browser, mobile
              device, and/or operating system. The owner cannot be held liable for any perceived or actual damages
              arising from Service content, operation, or use of this Service.</p>
            <p>Federal law, some states, and other jurisdictions, do not allow the exclusion and limitations of certain
              implied warranties. The above exclusions may not apply to Users. This Agreement gives Users specific legal
              rights, and Users may also have other rights which vary from state to state. The disclaimers and
              exclusions under this agreement shall not apply to the extent prohibited by applicable law.</p>
            <h4>Limitations of liability</h4>
            <p>To the maximum extent permitted by applicable law, in no event shall the Owner, and its subsidiaries,
              affiliates, officers, directors, agents, co-branders, partners, suppliers and employees be liable for:</p>
            <ul>
              <li>any indirect, punitive, incidental, special, consequential or exemplary damages, including without
                limitation damages for loss of profits, goodwill, use, data or other intangible losses, arising out of
                or relating to the use of, or inability to use, the Service;
              </li>
              <li>any damage, loss or injury resulting from hacking, tampering or other unauthorized access or use of
                the Service or User account or the information contained therein;
              </li>
              <li>any errors, mistakes, or inaccuracies of content;</li>
              <li>personal injury or property damage, of any nature whatsoever, resulting from User access to or use of
                the Service;
              </li>
              <li>any unauthorized access to or use of the Owner’s secure servers and/or any and all personal
                information stored therein;
              </li>
              <li>any interruption or cessation of transmission to or from the Service;</li>
              <li>any bugs, viruses, trojan horses, or the like that may be transmitted to or through the Service;</li>
              <li>any errors or omissions in any content or for any loss or damage incurred as a result of the use of
                any content posted, emailed, transmitted, or otherwise made available through the Service; and/or
              </li>
              <li>the defamatory, offensive, or illegal conduct of any User or third party.</li>
            </ul>
            <p>In no event shall the Owner, and its subsidiaries, affiliates, officers, directors, agents, co-branders,
              partners, suppliers and employees be liable for any claims, proceedings, liabilities, obligations,
              damages, losses or costs in an amount exceeding the amount paid by User to the Owner hereunder in the
              preceding 12 months, or the period of duration of this agreement between the Owner and User, whichever is
              shorter.</p>
            <p>This limitation of liability section shall apply to the fullest extent permitted by law in the applicable
              jurisdiction whether the alleged liability is based on contract, tort, negligence, strict liability, or
              any other basis, even if company has been advised of the possibility of such damage.</p>
            <p>Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages,
              therefore the above limitations or exclusions may not apply to User. The terms give User specific legal
              rights, and User may also have other rights which vary from jurisdiction to jurisdiction. The disclaimers,
              exclusions, and limitations of liability under the terms shall not apply to the extent prohibited by
              applicable law.</p>
            <h4>Indemnification</h4>
            <p>The User agrees to defend, indemnify and hold the Owner and its subsidiaries, affiliates, officers,
              directors, agents, co-branders, partners, suppliers and employees harmless from and against any and all
              claims or demands, damages, obligations, losses, liabilities, costs or debt, and expenses, including, but
              not limited to, legal fees and expenses, arising from:</p>

            <ul>
              <li>User’s use of and access to the Service, including any data or content transmitted or received by
                User;
              </li>
              <li>User’s violation of these terms, including, but not limited to, User’s breach of any of the
                representations and warranties set forth in these terms;
              </li>
              <li>User’s violation of any third-party rights, including, but not limited to, any right of privacy or
                intellectual property rights;
              </li>
              <li>User’s violation of any statutory law, rule, or regulation;</li>
              <li>any content that is submitted from User’s account, including third party access with User’s unique
                username, password or other security measure, if applicable, including, but not limited to, misleading,
                false, or inaccurate information;
              </li>
              <li>User’s willful misconduct; or</li>
              <li>statutory provision by User or its affiliates, officers, directors, agents, co-branders, partners,
                suppliers and employees to the extent allowed by applicable law.
              </li>
            </ul>
            <h3>Common provisions</h3>
            <h4>No Waiver</h4>
            <p>The Owner’s failure to assert any right or provision under these Terms shall not constitute a waiver of
              any such right or provision. No waiver shall be considered a further or continuing waiver of such term or
              any other term.</p>
            <h4>Service interruption</h4>
            <p>To ensure the best possible service level, the Owner reserves the right to interrupt the Service for
              maintenance, system updates or any other changes, informing the Users appropriately.</p>
            <p>Within the limits of law, the Owner may also decide to suspend or terminate the Service altogether. If
              the Service is terminated, the Owner will cooperate with Users to enable them to withdraw Personal Data or
              information in accordance with applicable law.</p>
            <p>Additionally, the Service might not be available due to reasons outside the Owner’s reasonable control,
              such as “force majeure” (e.g. labor actions, infrastructural breakdowns or blackouts etc).</p>
            <h4>Service reselling</h4>
            <p>Users may not reproduce, duplicate, copy, sell, resell or exploit any portion of skipprdata.com and of
              its Service without the Owner’s express prior written permission, granted either directly or through a
              legitimate reselling program.</p>
            <h4>Privacy policy</h4>
            <p>To learn more about the use of their Personal Data, Users may refer to the privacy policy of
              skipprdata.com.</p>
            <h4>Intellectual property rights</h4>
            <p>Without prejudice to any more specific provision of these Terms, any intellectual property rights, such
              as copyrights, trademark rights, patent rights and design rights related to skipprdata.com are the
              exclusive property of the Owner or its licensors and are subject to the protection granted by applicable
              laws or international treaties relating to intellectual property.</p>
            <p>All trademarks — nominal or figurative — and all other marks, trade names, service marks, word marks,
              illustrations, images, or logos appearing in connection with skipprdata.com are, and remain, the exclusive
              property of the Owner or its licensors and are subject to the protection granted by applicable laws or
              international treaties related to intellectual property.</p>
            <h4>Changes to these Terms</h4>
            <p>The Owner reserves the right to amend or otherwise modify these Terms at any time. In such cases, the
              Owner will appropriately inform the User of these changes.</p>
            <p>Such changes will only affect the relationship with the User for the future.</p>
            <p>The continued use of the Service will signify the User’s acceptance of the revised Terms. If Users do not
              wish to be bound by the changes, they must stop using the Service. Failure to accept the revised Terms may
              entitle either party to terminate the Agreement.</p>
            <p>The applicable previous version will govern the relationship prior to the User’s acceptance. The User can
              obtain any previous version from the Owner.</p>
            <p>If required by applicable law, the Owner will specify the date by which the modified Terms will enter
              into force.</p>
            <h4>Assignment of contract</h4>
            <p>The Owner reserves the right to transfer, assign, dispose of by novation, or subcontract any or all
              rights or obligations under these Terms, taking the User’s legitimate interests into account. Provisions
              regarding changes of these Terms will apply accordingly.</p>
            <p>Users may not assign or transfer their rights or obligations under these Terms in any way, without the
              written permission of the Owner.</p>
            <h4>Contacts</h4>
            <p>All communications relating to the use of skipprdata.com must be sent using the contact information
              stated in this document.</p>
            <h4>Severability</h4>
            <p>Should any provision of these Terms be deemed or become invalid or unenforceable under applicable law,
              the invalid
            <h4>US Users</h4>
            <p>Dispute resolution and governing law</p>
            <p>The formation, interpretation, and performance of this Agreement and any disputes arising out of it shall
              be governed by the substantive and procedural laws of California, United States without regard to its
              rules on conflicts or choice of law and, to the extent applicable, the laws of United States. The
              exclusive jurisdiction and venue for actions related to the subject matter hereof shall be the state and
              federal courts located in California, United States, and Users hereby submit to the personal jurisdiction
              of such courts. You hereby waive any right to a jury trial in any proceeding arising out of or related to
              this Agreement. The United Nations Convention on Contracts for the International Sale of Goods does not
              apply to this Agreement.</p>
            <h4>EU Users</h4>
            <p>Platform for online dispute resolution for consumers</p>
            <p>The European Commission has established an online platform for alternative dispute resolutions that
              facilitates an out-of-court method for solving any dispute related to and stemming from online sale and
              service contracts. As a result, any EU User can use such platform for resolving any dispute stemming from
              contracts which have been entered into online. The platform is available at the following link: <a
                href="https://ec.europa.eu/consumers/odr" target="_blank">https://ec.europa.eu/consumers/odr</a>.</p>
            <h4>Definitions and legal references</h4>
            <p>Latest update: September 08, 2021</p>
            <h4>Legal references</h4>
            <p>This privacy policy is drawn up on the basis of multiple legislative systems, including Articles 13 and
              14 of Regulation (EU) 2016/679 (General Data Protection Regulation).</p>
            <h4>Definitions</h4>
            <p>Legal references</p>
            <ul>
              <li>Service</li>
              <li>Service</li>
              <li>European Union (or EU)</li>
              <li>United States (or US)</li>
              <li>Cookie</li>
              <li>Personal Data</li>
              <li>Usage Data</li>
              <li>Data Controller</li>
              <li>Data Processor (or Service Providers)</li>
              <li>Data Subject</li>
              <li>User</li>
            </ul>
            <h4>Service</h4>
            <p>The Service is the website providing the functionality described in these Terms and in specific sections
              of skipprdata.com.</p>
            <h4>Usage Data</h4>
            <p>Information collected automatically through skipprdata.com (or third-party services employed in
              skipprdata.com) that can include: the IP addresses or domain names of the computers utilized by the Users
              who use skipprdata.com, the URI addresses (Uniform Resource Identifier), the time of the request, the
              method utilized to submit the request to the server, the size of the file received in response, the
              numerical code indicating the status of the server's answer (successful outcome, error, etc.), the country
              of origin, the features of the browser and the operating system utilized by the User, the various time
              details per visit (e.g., the time spent on each page within the Service) and the details about the path
              followed within the Service with special reference to the sequence of pages visited, and other parameters
              about the device operating system and/or the User's IT environment.</p>
            <h4>Personal Data</h4>
            <p>Any information that directly, indirectly, or in connection with other information — including a personal
              identification number — allows for the identification or identifiability of a natural person.</p>
            <h4>Information collected automatically</h4>
            <p>Information collected automatically through skipprdata.com (or third-party services employed in
              skipprdata.com), which can include: the IP addresses or domain names of the computers utilized by the
              Users who use skipprdata.com, the URI addresses (Uniform Resource Identifier), the time of the request,
              the method utilized to submit the request to the server, the size of the file received in response, the
              numerical code indicating the status of the server's answer (successful outcome, error, etc.), the country
              of origin, the features of the browser and the operating system utilized by the User, the various time
              details per visit (e.g., the time spent on each page within the Service) and the details about the path
              followed within the Service with special reference to the sequence of pages visited, and other parameters
              about the device operating system and/or the User's IT environment.</p>
            <h4>Data Controller (or Owner)</h4>
            <p>The natural or legal person, public authority, agency or other body which, alone or jointly with others,
              determines the purposes and means of the processing of Personal Data, including the security measures
              concerning the operation and use of skipprdata.com. The Data Controller, unless otherwise specified, is
              the Owner of skipprdata.com.</p>
            <h4>Data Processor (or Service Provider)</h4>
            <p>The natural or legal person, public authority, agency, or other body which processes Personal Data on
              behalf of the Data Controller, as described in this privacy policy.</p>
            <h4>Data Subject</h4>
            <p>The natural person to whom the Personal Data refers.</p>
            <h4>User</h4>
            <p>The individual using skipprdata.com who, unless otherwise specified, coincides with the Data Subject.</p>
            <h4>Legal information</h4>
            <p>This privacy statement has been prepared based on provisions of multiple legislations, including Art.
              13/14 of Regulation (EU) 2016/679 (General Data Protection Regulation).</p>
            <p>This privacy policy relates solely to skipprdata.com, if not stated otherwise within this document.</p>
            <p>Latest update: July 18, 2023</p>


          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'PaulHudson',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

